// For currency formatting reference check https://mcoproduct.atlassian.net/wiki/spaces/APP/pages/2922515660/Display+currencies+formatting+on+Main+App

// Usage: currencyFormatter('RUB', 4527911.42, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) for instance,
// 4527911.42 Ruble will be formatted to { symbol: ₽, value: 4,527,911.42 }, you can also restrict the significant
// digits of the number

// NOTE: According to design, symbol should be placed in the front of number -- ₽4,527,911.42

// TODO: Ideally this map should be retrieved from the backend. However, due to broken endpoint, we are not able to get the full list of data, will need to follow up on this in the future
import { getFiatCurrencyFormatOptions } from './'

export const currencySymbolMap: Record<string, string> = {
  EUR: '€',
  USD: '$',
  GBP: '£',
  CZK: 'Kč',
  TRY: '₺',
  AED: 'د.إ',
  AFN: '؋',
  ARS: '$',
  AUD: '$',
  BBD: '$',
  BDT: 'Tk',
  BGN: 'лв',
  BHD: 'BD',
  BMD: '$',
  BND: '$',
  BOB: '$b',
  BRL: 'R$',
  BTN: 'Nu.',
  BZD: 'BZ$',
  CAD: '$',
  CHF: 'CHF',
  CLP: '$',
  CNY: '¥',
  COP: '$',
  CRC: '₡',
  DKK: 'kr',
  DOP: 'RD$',
  EGP: '£',
  ETB: 'Br',
  GEL: '₾',
  GHS: '¢',
  GMD: 'D',
  GYD: '$',
  HKD: '$',
  HRK: 'kn',
  HUF: 'Ft',
  HTG: 'G',
  IDR: 'Rp',
  ILS: '₪',
  INR: '₹',
  ISK: 'kr',
  JMD: 'J$',
  JPY: '¥',
  KES: 'KSh',
  KRW: '₩',
  KWD: 'د.ك',
  KYD: '$',
  KZT: 'лв',
  LAK: '₭',
  LKR: '₨',
  LRD: '$',
  LTL: 'Lt',
  MAD: 'MAD',
  MDL: 'MDL',
  MKD: 'ден',
  MNT: '₮',
  MUR: '₨',
  MWK: 'MK',
  MXN: '$',
  MYR: 'RM',
  MZN: 'MT',
  NAD: '$',
  NGN: '₦',
  NIO: 'C$',
  NOK: 'kr',
  NPR: '₨',
  NZD: '$',
  OMR: '﷼',
  PEN: 'S/.',
  PGK: 'K',
  PHP: '₱',
  PKR: '₨',
  PLN: 'zł',
  PYG: 'Gs',
  QAR: 'ر.ق',
  RON: 'lei',
  RSD: 'Дин.',
  RUB: '₽',
  SAR: 'ر.س',
  SEK: 'kr',
  SGD: '$',
  XSGD: 'S',
  SOS: 'S',
  SRD: '$',
  THB: '฿',
  TTD: 'TT$',
  TWD: '$',
  TZS: 'TSh',
  UAH: '₴',
  UGX: 'USh',
  UYU: '$U',
  VEF: 'Bs',
  VND: '₫',
  YER: '﷼',
  ZAR: 'R',
}

export const reverseDisplayCurrency = ['AED', 'AFN', 'KWD', 'OMR', 'QAR', 'SAR', 'YER']

const defaultNumberFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export const currencyFormatter = (
  currency: string,
  number: number,
  options?: {
    minimumFractionDigits?: number
    maximumFractionDigits?: number
    maximumSignificantDigits?: number
    minimumSignificantDigits?: number
  },
) => {
  const currencySymbol = currencySymbolMap[currency] ?? '$'
  const currencyFormatForNumber = options
    ? new Intl.NumberFormat('en-US', options)
    : defaultNumberFormatter
  const numberString = currencyFormatForNumber.format(number)
  return {
    symbol: currencySymbol,
    value: numberString,
    shouldReverseDisplay: reverseDisplayCurrency.includes(currency),
  }
}

export const currencyPriceFormatter = (currency: string, price: number) => {
  return currencyFormatter(currency, price, getFiatCurrencyFormatOptions(price))
}
